import { observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import Paper from '@mui/material/Paper';
import { Grid, Stack, Typography, createTheme, useMediaQuery } from '@mui/material';
import './style.css';
import { datetimeFormatter } from '../../utils/datetimeFormatter';
import dayjs from 'dayjs';
import { isEmpty } from '../../utils/helper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

export const ReadOnlyClientPersonalInfo = observer(({ details }) => {
  const theme = createTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const [formChildren, setFormChildren] = useState([]);

  const getData = (value) => {
    return isEmpty(value) ? '_' : value;
  };

  useEffect(() => {
    setFormChildren(details?.children ? JSON.parse(details?.children) : []);
  }, [details]);

  return (
    <Paper sx={{ px: '30px', py: '20px', pb: '40px' }}>
      <Stack spacing={4}>
        <Stack spacing={3}>
          <Typography sx={{ fontWeight: '500', alignSelf: 'start' }} component="p">
            Client Personal Details
          </Typography>
          <Grid rowGap={2} container justifyContent={'space-evenly'}>
            <Grid item xs={12} sm={6} md={6} lg={6}>
              <Stack direction={'row'} width={'100%'} height={'100%'} spacing={4}>
                <Stack direction={'column'} spacing={2} sx={{ color: '#626A72', fontWeight: '500' }}>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'end',
                    }}
                    component="p"
                  >
                    Number of person's stay in the Home
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'end',
                    }}
                    component="p"
                  >
                    Community
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'end',
                    }}
                    component="p"
                  >
                    Community Other
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'end',
                    }}
                    component="p"
                  >
                    Type of Family
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'end',
                    }}
                    component="p"
                  >
                    Type of Family Other
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'end',
                    }}
                    component="p"
                  >
                    Client mother Toungh
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'end',
                    }}
                    component="p"
                  >
                    Client mother Toungh Other
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'end',
                    }}
                    component="p"
                  >
                    Client Prefered Language in Meeting
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'end',
                    }}
                    component="p"
                  >
                    Client Prefered Language in Meeting Other
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'end',
                    }}
                    component="p"
                  >
                    Client Mode of Transportation
                  </Typography>
                </Stack>
                <Stack direction={'column'} spacing={2}>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'start',
                    }}
                    component="p"
                  >
                    {getData(details?.numberOfPersonsStayInHome)}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'start',
                    }}
                    component="p"
                  >
                    {getData(details?.community)}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'start',
                    }}
                    component="p"
                  >
                    {getData(details?.communityOther)}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'start',
                    }}
                    component="p"
                  >
                    {getData(details?.typeOfFamily)}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'start',
                    }}
                    component="p"
                  >
                    {getData(details?.typeOfFamilyOther)}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'start',
                    }}
                    component="p"
                  >
                    {getData(details?.clientMotherToungh)}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'start',
                    }}
                    component="p"
                  >
                    {getData(details?.clientMotherTounghOther)}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'start',
                    }}
                    component="p"
                  >
                    {getData(details?.clientPreferedLanguageInMeeting)}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'start',
                    }}
                    component="p"
                  >
                    {getData(details?.clientPreferedLanguageInMeetingOther)}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'start',
                    }}
                    component="p"
                  >
                    {getData(details?.clientModeOfTransportation)}
                  </Typography>
                </Stack>
              </Stack>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6}>
              <Stack direction={'row'} width={'100%'} height={'100%'} spacing={4}>
                <Stack direction={'column'} spacing={2} sx={{ color: '#626A72', fontWeight: '500' }}>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'end',
                    }}
                    component="p"
                  >
                    Anniversary Date
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'end',
                    }}
                    component="p"
                  >
                    Husband DOB
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'end',
                    }}
                    component="p"
                  >
                    Wife DOB
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'end',
                    }}
                    component="p"
                  >
                    Prefered Drink
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'end',
                    }}
                    component="p"
                  >
                    Client Occupation
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'end',
                    }}
                    component="p"
                  >
                    Client Business Name
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'end',
                    }}
                    component="p"
                  >
                    Client Working Company
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'end',
                    }}
                    component="p"
                  >
                    Client Designation
                  </Typography>
                </Stack>
                <Stack direction={'column'} spacing={2}>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'start',
                    }}
                    component="p"
                  >
                    {details?.anniversaryDate
                      ? datetimeFormatter.formatDate(details?.anniversaryDate, datetimeFormatter.toLocal)
                      : '_'}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'start',
                    }}
                    component="p"
                  >
                    {details?.husbandDob
                      ? datetimeFormatter.formatDate(details?.husbandDob, datetimeFormatter.toLocal)
                      : '_'}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'start',
                    }}
                    component="p"
                  >
                    {details?.wifeDob ? datetimeFormatter.formatDate(details?.wifeDob, datetimeFormatter.toLocal) : '_'}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'start',
                    }}
                    component="p"
                  >
                    {getData(details?.preferedDrink)}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'start',
                    }}
                    component="p"
                  >
                    {getData(details?.clientOccupation)}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'start',
                    }}
                    component="p"
                  >
                    {getData(details?.clientBusinessName)}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'start',
                    }}
                    component="p"
                  >
                    {getData(details?.clientWorkingCompany)}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'start',
                    }}
                    component="p"
                  >
                    {getData(details?.clientDesignation)}
                  </Typography>
                </Stack>
              </Stack>
            </Grid>
          </Grid>
        </Stack>
        {formChildren.length > 0 && (
          <Stack spacing={3}>
            <Typography sx={{ fontWeight: '500', alignSelf: 'start' }} component="p">
              Children
            </Typography>
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell>Name</TableCell>
                    <TableCell>Gender</TableCell>
                    <TableCell>DOB</TableCell>
                    <TableCell>Age</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {formChildren.map((row, index) => (
                    <TableRow key={index} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                      <TableCell>{row.name}</TableCell>
                      <TableCell>{row.gender}</TableCell>
                      <TableCell>
                        {row?.dob ? datetimeFormatter.formatDate(row?.dob, datetimeFormatter.toLocal) : '_'}
                      </TableCell>
                      <TableCell>{row.age}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Stack>
        )}
        <Stack spacing={3}>
          <Typography sx={{ fontWeight: '500', alignSelf: 'start' }} component="p">
            Favorite Place
          </Typography>
          <Grid rowGap={2} container justifyContent={'space-evenly'}>
            <Grid item xs={12} sm={6} md={6} lg={6}>
              <Stack direction={'row'} width={'100%'} height={'100%'} spacing={4}>
                <Stack direction={'column'} spacing={2} sx={{ color: '#626A72', fontWeight: '500' }}>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'end',
                    }}
                    component="p"
                  >
                    Favorite Place In Mysore
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'end',
                    }}
                    component="p"
                  >
                    Favorite Place In Karnataka
                  </Typography>
                </Stack>
                <Stack direction={'column'} spacing={2}>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'start',
                    }}
                    component="p"
                  >
                    {getData(details?.favoritePlaceInMysore)}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'start',
                    }}
                    component="p"
                  >
                    {getData(details?.favoritePlaceInKarnataka)}
                  </Typography>
                </Stack>
              </Stack>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6}>
              <Stack direction={'row'} width={'100%'} height={'100%'} spacing={4}>
                <Stack direction={'column'} spacing={2} sx={{ color: '#626A72', fontWeight: '500' }}>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'end',
                    }}
                    component="p"
                  >
                    Favorite Place In India
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'end',
                    }}
                    component="p"
                  >
                    Favorite Place In World
                  </Typography>
                </Stack>
                <Stack direction={'column'} spacing={2}>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'start',
                    }}
                    component="p"
                  >
                    {getData(details?.favoritePlaceInIndia)}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'start',
                    }}
                    component="p"
                  >
                    {getData(details?.favoritePlaceInWorld)}
                  </Typography>
                </Stack>
              </Stack>
            </Grid>
          </Grid>
        </Stack>
      </Stack>
    </Paper>
  );
});
